export default __webpack_public_path__ + "static/media/Image_OB_ParaPassLink@3x.40fcfd1b.png";